import TopWorst from '../views/TopWorst'
import FragrancesAttributes from '../views/FragrancesAttributes'
import CategoryProfile from '../views/CategoryProfile'
import GroupComparison from '../views/GroupComparison'

export default [
  {
    path: '/topworst',
    name: 'topworst',
    meta: { auth: true, title: 'Best/Worst testers - IRIS' },
    component: TopWorst
  },
  {
    path: '/fragrance-profile',
    name: 'attributes',
    meta: { auth: true, title: 'Fragrance profile - IRIS' },
    component: FragrancesAttributes
  },
  {
    path: '/category-profile',
    name: 'category-profile',
    meta: { auth: true, title: 'Category profile - IRIS' },
    component: CategoryProfile
  },
  {
    path: '/group-comparison',
    name: 'group-comparison',
    meta: { auth: true, title: 'Group comparison - IRIS' },
    component: GroupComparison
  }
]
